<template>
  <accordion-item :title="$t('howToPay')" :onTrigger="onTrigger">
    <p>
      {{ $t('howToPayAnswerA') }}
    </p>
    <p>
      {{ $t('howToPayAnswerB') }}<reference-link :num="1">{{ $t('howToPayAnswerFN1') }}</reference-link>
    </p>
    <p>
      {{ $t('howToPayAnswerC') }}
    </p>
    <p>
      {{ $t('howToPayAnswerD') }}
    </p>
  </accordion-item>
</template>

<script>
import lang from '@/lang/Faqs';
import AccordionItem from '../AccordionItem.vue';
import ReferenceLink from '../ReferenceLink.vue';

export default {
  components: { AccordionItem, ReferenceLink },
  i18n: {
    messages: {},
    sharedMessages: lang,
  },
  props: {
    onTrigger: { type: Function, required: false, default: () => {} },
  },
  data() {
    return {
      accordionID: this.$parent.accordionID,
    };
  },
};
</script>
